import HowToRegIcon from "@mui/icons-material/HowToReg";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GroupsIcon from "@mui/icons-material/Groups";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import EqualizerIcon from "@mui/icons-material/Equalizer";

export const adminArr = [
  {
    id: "add_facility",
    name: "Facility management",
    path: "facility_details",
    icon: <DomainAddIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  // {
  //   id: "add_customer",
  //   name: "Add New Customer",
  //   path: "customer_details",
  //   icon: <GroupsIcon style={{ color: "white", transform: "scale(2)" }} />,
  // },
  // {
  //   id: "add_partner",
  //   name: "Add New Partner",
  //   path: "partner_details",
  //   icon: <HandshakeIcon style={{ color: "white", transform: "scale(2)" }} />,
  // },
  {
    id: "add_user",
    name: "User management",
    path: "user_details",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "add_doctor",
    name: "Doctor management",
    path: "facility_doctors",
    icon: (
      <LocalHospitalIcon style={{ color: "white", transform: "scale(2)" }} />
    ),
  },
  {
    id: "transaction_and_billing",
    name: "Billing and transection",
    path: "transaction_records",
    icon: (
      <CurrencyRupeeIcon style={{ color: "white", transform: "scale(2)" }} />
    ),
  },
  {
    id: "manage_branding",
    name: "Branding management",
    path: "manage_branding",
    icon: (
      <BrandingWatermarkIcon
        style={{ color: "white", transform: "scale(2)" }}
      />
    ),
  },
  {
    id: "update_department",
    name: "Department management",
    path: "DepartmentManipulation",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "reports",
    name: "Report and anlytics",
    path: "reports",
    icon: <EqualizerIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
  {
    id: "scan_share_records",
    name: "Scan & Share Records",
    path: "scan_share_records",
    icon: <HowToRegIcon style={{ color: "white", transform: "scale(2)" }} />,
  },
];
const withEhr = [
  "add_user",
  "add_doctor",
  "transaction_and_billing",
  "update_department",
  "reports",
];
const withoutEhr = ["add_user", "transaction_and_billing", "reports"];
export const adminAccessMapping = {
  admin: [
    "add_facility",
    "add_customer",
    "add_partner",
    "add_user",
    "add_doctor",
    "transaction_and_billing",
  ],
  "partner admin": [
    // "add_user", "add_customer",
    "transaction_and_billing",
  ],
  "customer admin": [
    "add_user",
    "add_facility",
    "transaction_and_billing",
    // "manage_branding",
    "reports",
  ],
  // "facility admin": [
  //   "add_user",
  //   "add_doctor",
  //   "transaction_and_billing",
  //   "update_department","reports"
  // ],
  "facility admin": {
    "EHR/HMIS Service With ABDM Connector - HIU/HIP": [
      ...withEhr,
      "scan_share_records",
    ],
    "EHR/HMIS Service Without ABDM Connector": [...withEhr],

    "ABDM Connector/Adaptor - HIU/HIP": [...withoutEhr],
    "ABDM Connector/Adaptor - HIU": [...withoutEhr],
    "ABDM Connector/Adaptor - HIP": [...withoutEhr],
    "Health Repository Provider (HRP) Service - HIU/HIP": [
      ...withoutEhr,
      "scan_share_records",
    ],
    "Health Repository Provider (HRP) Service - HIU": [
      ...withoutEhr,
      "scan_share_records",
    ],
    "Health Repository Provider (HRP) Service - HIP": [
      ...withoutEhr,
      "scan_share_records",
    ],
  },
};
